import { render, staticRenderFns } from "./CurrentBookReading.vue?vue&type=template&id=38013f3d&scoped=true&"
import script from "./CurrentBookReading.vue?vue&type=script&lang=js&"
export * from "./CurrentBookReading.vue?vue&type=script&lang=js&"
import style0 from "./CurrentBookReading.vue?vue&type=style&index=0&id=38013f3d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38013f3d",
  null
  
)

export default component.exports